import React from 'react';
import { cn } from '../../Helpers/cn';
import { get } from '../../Services/http';

/**
 * Order status label component
 * @param {Object} props - Component props
 * @param {string} [props.className] - Additional CSS classes
 * @param {string} [props.status] - Order status
 * @param {"red" | "blue" | "green"} [props.color] - Order status color
 * @param {React.ComponentProps<"span">} props - All span element props
 * @returns {React.JSX.Element} Span element with order status
 */
const OrderStatus = ({ status, color, className, ...props }) => {
  return (
    <span
      className={cn('flex items-center gap-1', getColorClass(color), className)}
      {...props}
    >
      <span className="bg-current size-2 rounded-full" />
      {status}
    </span>
  );
};

/**
 *
 * @param {"red" | "blue" | "green"} color
 */
const getColorClass = (color) => {
  switch (color) {
    case 'red':
      return 'text-error';
    case 'blue':
      return 'text-information';
    case 'green':
      return 'text-success';
    default:
      return '';
  }
};

export default OrderStatus;
